var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
var SubmitButton = function (_a) {
    var loading = _a.loading, disabled = _a.disabled, className = _a.className, onClick = _a.onClick, children = _a.children, _b = _a.type, type = _b === void 0 ? "button" : _b;
    return (_jsx("button", __assign({ type: type, disabled: disabled || loading, onClick: onClick, className: classNames(className, { loading: loading }) }, { children: !loading && children })));
};
SubmitButton.propTypes = {
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.node,
    type: PropTypes.string
};
SubmitButton.defaultProps = {
    loading: false,
    disabled: false,
    className: "",
    onClick: undefined,
    children: null,
    type: "button"
};
export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/shared/ui/SubmitButton.jsx